export const boardSideMenuTour = {
  key: "boardSideMenu",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-sidemenu-notices"]',
      content: t("Tour_BoardSideMenu_Notices"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-sidemenu-project"]',
      content: t("Tour_BoardSideMenu_Project"),
      placement: "right",
    },
    {
      target: '[data-tour="board-sidemenu-team"]',
      content: t("Tour_BoardSideMenu_Team"),
      placement: "right",
    },
    {
      target: '[data-tour="board-sidemenu-tools"]',
      content: t("Tour_BoardSideMenu_Tools"),
      placement: "right",
    },
    {
      target: '[data-tour="board-sidemenu-pin"]',
      content: t("Tour_BoardSideMenu_Pin"),
      placement: "right",
    },
  ],
};
